/*
 *
 * InteractiveArea
 *
 */

import React from 'react';
import { useSelector } from 'react-redux';
import { useInjectReducer } from 'utils/injectReducer';
import { createStructuredSelector } from 'reselect';
import { selectMessage } from './selectors';
import reducer from './reducer';
import { RootState } from './types';
import { Message } from 'containers/InteractiveArea/Message';
import MessageEntry from 'containers/InteractiveArea/MessageEntry';
import { animated, useTransition } from 'react-spring';

interface StateProps {
  messages: Message[];
}

const stateSelector = createStructuredSelector<RootState, StateProps>({
  messages: selectMessage(),
});

function InteractiveArea() {
  useInjectReducer({ key: 'interactiveArea', reducer: reducer });
  const { messages } = useSelector(stateSelector);

  const transitions = useTransition(messages, message => message.message, {
    from: { transform: 'translateX(100%)' },
    enter: { transform: 'translateY(0%)' },
    leave: { opacity: 0 },
  });

  return (
    <>
      {transitions.map(({ item, props, key }) => (
        <AnimatedMessageEntry key={key} message={item} style={props} />
      ))}
    </>
  );
}

const AnimatedMessageEntry = animated(MessageEntry);

export default InteractiveArea;
